<template>
    <div>
      <Header></Header>
      <div class="box">
      <div class="head-a">
        <img src="static/images/logo2.png" alt="">
      </div>
      <div class="content">
        <div>
          <h1>价格说明（采集结果都是<span style="color:red;">日度数据</span>）</h1>
          <div style="font-size:16px;">
            <h3>1）自助采集服务</h3>
            <div class="tx-box">
              <h4>- 按次数购买</h4>
              <p> 按百度指数请求次数计费，1次请求0.05元，一次请求定义：1个词查询一个地区1年的数据。比如：查关键词“天气”，北京地区，2019年全年数据，不足年的按1年算</p>
              <br>
              <p>所需总次数 = 词数 * 年数 * 地区数 （说明：全国总数按一个地区算，不足年的按1年算）</p>
              <br>

              <p style="text-align:left;color:red; font-size:28px">促销活动价格列表</p>
              <p> 5元150个请求次数，6.6折 &nbsp;&nbsp;<span class="hx">（原价100个请求次数）</span></p>
              <p> 50元2100个请求次数，4.7折 &nbsp;&nbsp;<span class="hx">（原价1100个请求次数，9折）</span></p>
              <p> 100元5500个请求次数，3.6折 &nbsp;&nbsp;<span class="hx">（原价2400个请求次数，8.3折）</span></p>
              <br>
              <p>注意：最低起步价5元</p>
              <!-- ，查询次数有效期3个月，超过3个月会自动失效。 -->
              <p style="text-align:center;color:blue; font-size:28px">新注册用户送10个请求次数,可立即体验</p>
              <!-- <p style="margin:20px 0;">淘宝购买链接
                <a href="https://item.taobao.com/item.htm?spm=a21dvs.23580594.0.0.621e3d0dLDaHho&ft=t&id=660750528609" target="_blank" class="tao">点击这里进入</a>
                或者扫描最下面的二维码加客服微信直接充值
              </p> -->
              <br>
              <p><span style="color:red">微信直接充值，</span>客服微信：<span style="color:red">uunn688688</span>，直接微信转账给客服，并把你在本站的<span style="color:red">账号发给客服</span>，用于充值。</p>
            </div>
            <div class="tb-box">
              <h4>- 按时长租用</h4>
              <Table border :row-class-name="rowClassName" :columns="columns" :data="data"></Table>
            </div>
            <h3>2）支付方式</h3>
            <div class="tx-box">
              <p>1.微信直接充值</p>
              <p>方法：扫二维码加客服微信，直接微信转账给客服，并把你在本站的<span style="color:red">账号发给客服</span>（注册用的那个邮箱），用于充值。</p>
              <br>
              <div style="text-align:center;">
                <img style="width:300px;height:300px;" src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/qrcode.png" alt="">
              </div>
              <p>2.淘宝购买
                  <a href="https://item.taobao.com/item.htm?spm=a21dvs.23580594.0.0.621e3d0dLDaHho&ft=t&id=660750528609" target="_blank" class="tao">点击这里进入</a>
                </p>
                <br>
                <p>支付完成后，通过淘宝旺旺将你在本站注册的<span style="color:red">账号发给客服</span>，用于充值。</p>
                <br>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
</template>
<script>
import Header from './header'

export default {
  components: {
    Header
  },

  data () {
    return {
      columns: [
        {
          title: '功能对比',
          key: 'name'
        },
        {
          title: '黄金VIP',
          key: 'vip1'
        },
        {
          title: '铂金VIP',
          key: 'vip2'
        },
        {
          title: '至尊VIP',
          key: 'vip3'
        }
      ],
      data: [
        {
          name: '同时输入关键字数',
          vip1: '最多5个词',
          vip2: '最多10个词',
          vip3: '最多500个词'
        },
        {
          name: '同时选择地区数',
          vip1: '1个',
          vip2: '5个',
          vip3: '不限制'
        },
        {
          name: '时间选择',
          vip1: '2011年后任意时段',
          vip2: '2011年后任意时段',
          vip3: '2011年后任意时段'
        },
        {
          name: '采集次数',
          vip1: '不限制次数',
          vip2: '不限制次数',
          vip3: '不限制次数'
        },
        {
          name: '自动保存本地',
          vip1: '支持',
          vip2: '支持',
          vip3: '支持'
        },
        {
          name: '原价格',
          vip1: '39元/月，119元/年',
          vip2: '60元/天，150元/周，300元/月，1200元/年',
          vip3: '200元/天，500元/周，1200元/月，3000元/年'
        },
        {
          name: '活动价格',
          vip1: '37元/月，89元/年',
          vip2: '49元/天，119元/周，279元/月，979元/年',
          vip3: '149元/天，449元/周，979元/月，2799元/年'
        }
      ]
    }
  },
  mounted () {
  },
  methods: {
    rowClassName (row, index) {
      if (index === 5) {
        return 'old-price'
      } else if (index === 6) {
        return 'act-price'
      }
      return ''
    }
  }
}
</script>
<style lang="less">
@media (max-width: 768px){
  .box {
    width: 90vw !important;
  }
  .tx-box {
    margin: 0 !important;
  }
  .tb-box {
    margin: 40px 0 !important;
  }

}

a:hover {
  color: #177ff5;
}
// a:link{color: #177ff5;}
a:visited{color: #fff;}
.ivu-table .act-price td{
  // background-color: #2db7f5;
  color: red;
}
.ivu-table .old-price td{
  // color: red;
  text-decoration: line-through;
}
// .act-price {
//   color: red;
//   font-size: 38px;
// }
.tao {
  color: #fff;
  background-color: #ec971f;
  border-color: #d58512;
  padding: 4px 8px;
  border-radius: 5px;
}
.box {
  margin: 60px auto;
  width: 60vw;
}
.head-a {
  background: #398dee;
  border-radius: 7px;
  padding: 20px;
}
.content {
  text-align: left;
  margin: 20px 0;
  padding: 20px;
}
.tx-box {
  margin: 0 40px;
}
.tb-box {
  margin: 40px;
}
.info {
  font-size: 18px;
  line-height: 34px;
  margin: 20px 0;
}
.hx {
  color: #999aaa;
  text-decoration:line-through;
}
</style>



// WEBPACK FOOTER //
// src/components/intr_price.vue